module.exports = __webpack_public_path__ + "static/media/pristine.7fc96137.mp3";